module.exports = __webpack_public_path__ + "img/hr-H-B-6-load-standup-shadow.48448f61.png";